const initialState = {
  responseStageRangeList: {
    count: 0,
    next: null,
    previous: null,
    results: []
  },
  responseStageRangeDetail: null,
  responseCreate: null,
  responseUpdate: null,
  responseDelete: { success: false },
  loading: false,
  error: null
};

const stageRangeReducer = (state = initialState, action) => {
  switch (action.type) {

    case "STAGE_RANGE_REQUEST":
    case "STAGE_RANGE_DETAIL_REQUEST":
      return {
        ...state,
        loading: true,
        error: null,
        ...(action.type === "STAGE_RANGE_DETAIL_REQUEST" && {
          responseStageRangeDetail: null
        })
      };

    case "STAGE_RANGE_CREATE_REQUEST":
      return {
        ...state,
        loading: true,
        error: null,
        responseCreate: null
      };

    case "STAGE_RANGE_UPDATE_REQUEST":
      return {
        ...state,
        loading: true,
        error: null,
        responseUpdate: null
      };

    case "STAGE_RANGE_LIST_RESPONSE":
      return {
        ...state,
        loading: false,
        responseStageRangeList: action.value,
        error: null
      };


    case "STAGE_RANGE_DETAIL_RESPONSE":
      return {
        ...state,
        loading: false,
        responseStageRangeDetail: action.value,
        error: null
      };

    case "STAGE_RANGE_CREATE_RESPONSE":
      return {
        ...state,
        loading: false,
        responseCreate: action.value,
        error: null
      };

    case "STAGE_RANGE_UPDATE_RESPONSE":
      return {
        ...state,
        loading: false,
        responseUpdate: action.value,
        error: null
      };

    case "STAGE_RANGE_DELETE_RESPONSE":
      return {
        ...state,
        responseDelete: action.value
      };

    case "STAGE_RANGE_ERROR":
    case "STAGE_RANGE_CREATE_ERROR":
    case "STAGE_RANGE_UPDATE_ERROR":
      return {
        ...state,
        loading: false,
        error: action.error
      };

    case "STAGE_RANGE_CLEAR_STATE":
      return {
        ...state,
        error: null,
        responseCreate: null,
        responseUpdate: null,
      };

    default:
      return state;
  }
};

export default stageRangeReducer;
